import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Alert, FormFeedback } from 'reactstrap';
import styled from 'styled-components';
import {ReactComponent as KataIcon} from '../../assets/kata-icon.svg';
import CryptoJS from 'crypto-js';

const StyledLoginContainer = styled(Container)`
    display: flex;
    text-align: left;
    height: 100vh;
`;

const RowLogin = styled(Row)`
    margin: auto;
    width: 100%;
`

export const LoginTitle = styled.div`
    display: flex;
    margin-bottom: 20px;
    & svg {
        margin-right: 10px;
    }
    & h4 {
        margin-top: auto;
        margin-bottom: 0px;
    }
    & h5 {
        margin-top: auto;
        margin-bottom: 0px;
    }
`

const defaultRecord = {
    username: '',
    password: ''
}

const Login = ({
    handleLogin = () => console.log('for logged in callback'),
}) => {
    const [record, setRecord] = useState(defaultRecord);
    const [errorUsername, setErrorUsername] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [error, setError] = useState(null);

    const checkLogin = () => {
        const authenticated = Cookies.get("gen.client.authentication");

        if (authenticated) {
            handleLogin(true)
        }
    }

    const submitLogin = async () => {
        setError(null)
        setErrorUsername(false)
        setErrorPassword(false)
        if (record.username === "" || record.password === "") {
            setErrorUsername(record.username === "")
            setErrorPassword(record.password === "")
        } else {
            let data = JSON.stringify({
                "username": record.username,
                "password": record.password
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: process.env.REACT_APP_AUTH_URL,
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : data
            };

            await axios.request(config)
                .then(async (response) => {
                    if (response.data && response.data.token) {
                        await Cookies.set("gen.client.authentication",
                            CryptoJS.AES.encrypt(JSON.stringify(response.data), 'my-secret-key@123').toString()
                            , {
                                expires: response.data.expiry_date ? new Date(response.data.expiry_date * 1000) : 8,
                                sameSite: 'strict'
                            })
                        const username = Cookies.get("gen.client.username.chatbot");
                        const chatNumber = Cookies.get("gen.client.number.chatbot");

                        await Cookies.set("gen.client.username.chatbot", username ? username : record.username);
                        await Cookies.set("gen.client.number.chatbot", chatNumber ? chatNumber : Date.now());
                        handleLogin(true)
                    } else {
                     setError('Something went wrong...');
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.message) {
                        setError(error.response.data.message);
                    } else {
                        setError(error.message ? error.message : 'Something went wrong...');
                    }
                });
        }
    }

    useEffect(() => {
        checkLogin()
        // eslint-disable-next-line
    }, [])

    return (
        <StyledLoginContainer>
            <RowLogin>
                <Col sm={{ size: 6, offset: 3 }}>
                    <LoginTitle>
                        <KataIcon /> 
                        <h4>Gen-ui Login</h4>
                    </LoginTitle> 
                    <Form>
                        {error && <Alert color="danger">{error}</Alert>}
                        <FormGroup>
                            <Label for="username">Username</Label>
                            <Input 
                                type="text" 
                                name="username" 
                                id="username" 
                                invalid={errorUsername}
                                placeholder="Enter your username" 
                                onChange={(e) => {
                                    setRecord({
                                        ...record,
                                        [e.target.name]: e.target.value
                                    })
                                }}
                            />
                            <FormFeedback>
                                Username is required field
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Password</Label>
                            <Input 
                                type="password" 
                                name="password" 
                                id="password" 
                                placeholder="Enter your password" 
                                invalid={errorPassword}
                                onChange={(e) => {
                                    setRecord({
                                        ...record,
                                        [e.target.name]: e.target.value
                                    })
                                }}
                            />
                            <FormFeedback>
                                Password is required field
                            </FormFeedback>
                        </FormGroup>
                        <Button color="primary" block type="button" onClick={() => submitLogin()}>Login</Button>
                    </Form>
                </Col>
            </RowLogin>
        </StyledLoginContainer>
    );
};

export default Login;
